<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车牌号" prop="vehicleNo">
            <el-input
              clearable
              v-model="formData.vehicleNo"
              placeholder="请输入车牌号"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车型" prop="vehicleModel">
            <dict-select
              clearable
              v-model="formData.vehicleModel"
              filterable
              placeholder="请选择车型"
              style="width: 100%"
              default
              :body="vehicleModelDictParams"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车牌类型" prop="vehicleLicenseType">
            <dict-select
              v-model="formData.vehicleLicenseType"
              placeholder="请选择车牌类型"
              style="width: 100%"
              default
              filterable
              clearable
              :body="plateTypeDictParams"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车辆品牌" prop="vehicleBrand">
            <dict-select
              clearable
              v-model="formData.vehicleBrand"
              placeholder="请输入车辆品牌"
              default
              filterable
              :body="vehicleBrandDicyParams"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车辆行驶证号" prop="vehicleLicense">
            <el-input
              clearable
              v-model="formData.vehicleLicense"
              placeholder="请输入车辆行驶证号"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车辆行驶证有效期" prop="vehicleLicenseValidity">
            <el-date-picker
              v-model="formData.vehicleLicenseValidity"
              type="date"
              style="width:100%"
              value-format="yyyy-MM-dd"
              placeholder="请输入车辆行驶证有效期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="购车日期" prop="purchaseDate">
            <el-date-picker
              v-model="formData.purchaseDate"
              type="date"
              placeholder="选择购车日期"
              style="width:100%"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="体积">
            <el-input-number
              style="width:100%"
              clearable
              controls-position="right"
              v-model="formData.vehicleVolume"
              :min="0"
              size="mini"
              :max="162142895431250380000"
              :step="0.0001"
              :precision="4"
              placeholder="请输入车辆体积"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车长（米）" prop="vehicleLength">
            <dict-select
              style="width: 100%"
              default
              :body="vehicleLengthDictParams"
              clearable
              filterable
              v-model="formData.vehicleLength"
              placeholder="请选择车长"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="载重(吨)">
            <el-input-number
              style="width:100%"
              clearable
              controls-position="right"
              v-model="formData.vehicleLoad"
              placeholder="请输入车辆载重"
              :min="0"
              size="mini"
              :max="162142895431250380000"
              :step="0.0001"
              :precision="4"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车辆行驶证到期提醒天数">
            <el-input-number
              style="width:100%"
              controls-position="right"
              clearable
              v-model="formData.vehicleLicenseValidityAlarmDays"
              :min="0"
              :step="1"
              :precision="0"
              placeholder="请输入车辆行驶证到期提醒天数"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="上牌日期" prop="registrationDate">
            <el-date-picker
              type="date"
              v-model="formData.registrationDate"
              placeholder="选择车辆上牌日期"
              style="width:100%"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="保险到期日期" prop="insuranceDate">
            <el-date-picker
              type="date"
              v-model="formData.insuranceDate"
              placeholder="选择保险到期日期"
              style="width:100%"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="年检到期日期" prop="inspectionDate">
            <el-date-picker
              type="date"
              v-model="formData.inspectionDate"
              placeholder="选择年检到期日期"
              style="width:100%"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="承运商" prop="carrierCode">
            <dict-select
              style="width: 100%"
              clearable
              size="medium"
              filterable
              v-model="formData.carrierCode"
              url="/master/carrier/info/select"
              placeholder="请选择承运商"
              @change="changeCarrierCode()"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="所属机构" prop="orgCode">
            <org-cascader
              clearable
              :valueString.sync="formData.orgAllCode"
              :lastValue.sync="formData.orgCode"
              filterable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车辆归属" prop="vehicleOwnerType">
            <dict-select
              clearable
              filterable
              v-model="formData.vehicleOwnerType"
              placeholder="请选择车辆归属"
              default
              :body="vehicleOwnerTypeDictParams"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="车辆审核状态" prop="vehicleInspectionStatus">
            <dict-select
              clearable
              filterable
              v-model="formData.vehicleInspectionStatus"
              placeholder="请选择车辆审核状态"
              default
              :body="vehicleInspectionStatusDictParams"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="数据来源" prop="dataSource">
            <dict-select
              clearable
              filterable
              v-model="formData.dataSource"
              placeholder="请选择数据来源"
              default
              :body="vehicleDataSourceParams"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="可用状态" prop="vehicleStatus">
            <el-radio-group v-model="formData.vehicleStatus">
              <el-radio label="Y">可用</el-radio>
              <el-radio label="N">不可用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
          <el-form-item label="备注" prop="vehicleRemarks">
            <el-input
              v-model="formData.vehicleRemarks"
              placeholder="请输入备注信息"
              type="textarea"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'

export default {
  props: {
    disabled: Boolean,
    code: String,
  },
  data() {
    return {
      vehicleLengthDictParams: { type: 'vehicleLength' },
      vehicleInspectionStatusDictParams: { type: 'vehicleInspectionStatus' },
      vehicleOwnerTypeDictParams: { type: 'vehicleOwnerType' },
      vehicleDataSourceParams: { type: 'dataSource' },
      vehicleBrandDicyParams: { type: 'vehicleBrand' },
      plateTypeDictParams: { type: 'vehicleLicenseType' },
      vehicleModelDictParams: { type: 'vehicleModel' },
      formData: {
        vehicleStatus: 'Y',
      },
      rules: {
        vehicleNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          {
            validator(rule, value, callback) {
              let plateNo = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/

              if (plateNo.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的车牌号'))
              }
            },
          },
        ],
        vehicleModel: [
          { required: true, message: '请选择车型', trigger: 'blur' },
        ],
        vehicleLength: [
          { required: true, message: '请选择车长', trigger: 'blur' },
        ],
        vehicleOwnerType: [
          { required: true, message: '请选择车辆归属', trigger: 'change' },
        ],
        vehicleStatus: [
          { required: true, message: '请选择可用状态', trigger: 'change' },
        ],
        vehicleLoad: [
          { required: true, message: '请输入车辆载重', trigger: 'blur' },
        ],
        vehicleLicenseValidityAlarmDays: [
          {
            required: true,
            message: '请选择车辆行驶证到期提醒天数',
            trigger: 'blur',
          },
        ],
        carrierCode: [
          { required: true, message: '请选择承应商', trigger: 'change' },
        ],
        orgCode: [
          { required: true, message: '所属机构不能为空', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .masterVehicleDetailApi({
          vehicleCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
          this.$emit('changeCarrierCode',this.formData.carrierCode)
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        return
      }
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterVehicleSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('changeCode', res.body.vehicleCode)
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    changeCarrierCode(){
      if (this.code && this.formData.carrierCode){
        this.delDriverByVehicle()
        this.$api.masterVehicleModiCarrierApi({vehicleCode: this.code, carrierCode: this.formData.carrierCode})
        this.$emit('changeCarrierCode',this.formData.carrierCode)
      }
    },
    delDriverByVehicle(){
      const params = {
        vehicleCode: this.code,
        carrierCode: this.formData.carrierCode,
      }
      this.$api.masterVehicleDelDriverByVehicleApi(params).then(() => {})
    },
  },
}
</script>
